import React from 'react';
import takeOffMarker from './assets/takeoff.svg';
import { Marker } from '@react-google-maps/api';
import { TakeOffMarkerProps, TakeOffMarkerVariant } from './types';
import confirmedMarker from './assets/takeoff-confirmed.svg';

const TakeOffMarker: React.FC<TakeOffMarkerProps> & TakeOffMarkerVariant = (props) => (
  <TakeOffMarker.default {...props} />
);

TakeOffMarker.default = (props) => (
  <Marker 
    icon={{ 
      url: takeOffMarker, 
      anchor: new window.google.maps.Point(12, 32),
    }}
    {...props} />
);

TakeOffMarker.confirmed = (props) => (
  <Marker 
    icon={{ 
      url: confirmedMarker, 
      anchor: new window.google.maps.Point(12, 32),
    }}
    {...props} />
);

export default TakeOffMarker;